export const FAST_POLLING_INTERVAL = 5000;

export const SLOW_POLLING_INTERVAL = 15000;
